
import { PopupControl } from '../../models/popup-control.model';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-control-pop-up',
    templateUrl: './control-pop-up.component.html',
    styleUrls: ['./control-pop-up.component.scss'],
    standalone: false
})
export class ControlPopUpComponent implements OnInit {

	@Input()
	public popupControl: PopupControl;

	public onShowing(evt: any) {
		let content: HTMLElement = <HTMLElement>(evt.component.content().parentElement);

		if (!content.classList.contains("control-pop-up")) {
			content.classList.add("control-pop-up");
		}
	}

	constructor(
	) { }

	ngOnInit(): void {
	}
}
